import { render, staticRenderFns } from "./OnlineEventList.vue?vue&type=template&id=c82c5cd6&"
import script from "./OnlineEventList.vue?vue&type=script&lang=js&"
export * from "./OnlineEventList.vue?vue&type=script&lang=js&"
import style0 from "./OnlineEventList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports